import gsap from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, TextPlugin);

const gsapAnimation = ({
  x = "100%",
  y = 50,
  h1 = "",
  duration = 2,
  ease = "none",
  textTransform = "capitalize",
  start = "top 100%",
  toggleActions = "restart none none none",
  pin = false,
}) => {
  const beforeEnterH1 = (el) => {
    gsap.from(el, {
      scale: 0.8,
    });
  };
  const enterH1 = (el, done) => {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start,
        toggleActions,
      },
      duration,
      delay: 0.5,
      scale: 1,
      textTransform,
      text: {
        value: h1,
        speed: 0.3,
      },
      onComplete: done,
    });
  };
  const beforeEnter = (el) => {
    gsap.from(el, {
      opacity: 0,
      y,
    });
  };
  const enter = (el) => {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        pin,
        start: el.dataset.index
          ? `top ${100 - el.dataset.index * 5}%`
          : `top 95%`,
      },
      ease,
      opacity: 1,
      y: 0,
    });
  };
  const beforeEnterBox = (el) => {
    gsap.from(el, {
      opacity: 0,
      x: el.dataset.index ? (el.dataset.index % 2 ? x : "-100%") : x,
    });
  };
  const enterBox = (el, done) => {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: el.dataset.index ? `0% ${95 - el.dataset.index * 3}%` : `0% 85%`,
        end: el.dataset.index ? `0% ${35 + el.dataset.index * 3}%` : `0% 25%`,
      },
      opacity: 1,
      x: 0,
      delay: el.dataset.index * 0.2,
      onComplete: done,
    });
  };
  const stick = () => {
    const navbar = document.querySelector("nav");
    const menu = document.querySelector(".menu");
    const button = document.querySelector(".to-up");
    const sticky = navbar.offsetTop;
    if (window.pageYOffset >= sticky) {
      menu.classList.add("sticky");
    } else {
      menu.classList.remove("sticky");
    }
    // handle to up button
    if (window.pageYOffset >= sticky * 1.2) {
      button.classList.add("fix");
    } else {
      button.classList.remove("fix");
    }
  };
  return {
    stick,
    beforeEnterH1,
    enterH1,
    beforeEnter,
    enter,
    beforeEnterBox,
    enterBox,
  };
};
export default gsapAnimation;
